module.exports = __webpack_public_path__ + "media/flags/wf-cd857ddf.svg";